routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.templates', {
      url: "plantillas",
      template: `<templates sh-ctrl="shCtrl"></templates>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/templates/templates.config.js
 **/